'use strict';

module.exports = /*@ngInject*/ ["$timeout", function screenLogger($timeout) {
    return {
        restrict: 'EA',
        require: '^ngModel',
        scope: {
            ngModel: '=',
            divWidth: '=',
            divHeight: '='
        },
        template: [
            '<div class="pull-left relative" ng-style="{\'width\': divWidth, \'height\': divHeight}">',
            '<div id="logger-container" class="logger-code pull-left fullwidth fullheight overflow-y-auto" ng-click="cancelScroll()">',
            '<div ng-repeat="entry in log">',
            '<p ng-if="$last" id="last-logger-element">{{entry}}</p>',
            '<p ng-if="!$last">{{entry}}</p>',
            '</div>',
            '</div>',
            '<div class="width-50px absolute" style="right: 2px; top: 0px; z-index: 99;">',
            '<div type="button" ng-show="!scrollToBottom" class="btn btn-default btn-sm" ng-click="activateScroll();">',
            '<i class="fa fa-link"></i>',
            '</div>',
            '<div type="button" ng-show="scrollToBottom" class="btn btn-default btn-sm" ng-click="cancelScroll();">',
            '<i class="fa fa-chain-broken"></i>',
            '</div>',
            '</div>',
            '<div>'
        ].join(''),
        link: function (scope, element) {
            "use strict";
            scope.log = [];
            scope.scrollToBottom = true;
            scope.child = element[0].children[0];
            scope.$watch('ngModel.changed', function (newValue) {
                "use strict";
                if (newValue) {
                    scope.log = scope.ngModel.getLog();
                    if (scope.scrollToBottom) {
                        $timeout(function () {
                            document.getElementById("last-logger-element").scrollIntoView(true);
                        });
                    }
                }
            });

            scope.cancelScroll = function () {
                scope.scrollToBottom = false;
            };

            scope.activateScroll = function () {
                scope.scrollToBottom = true;
            };


            $('#logger-container').bind('scroll', function () {
                var child = element[0].children;
                if (child[0].offsetHeight + child[0].scrollTop >= child[0].scrollHeight) {
                    scope.scrollToBottom = true;
                }
            })
        }
    }
}];